export default "__VITE_ASSET__DyGbraIA__"